// ثوابت PDF
export const PDF_CONFIG = {
  PAGE_WIDTH: 210, // mm
  PAGE_HEIGHT: 297, // mm
  CANVAS_WIDTH: 794,
  IMAGE_QUALITY: 0.9,
  SCALE: 2,
  WAIT_TIME: 2000, // ms
} as const;

// أنماط PDF المضمنة
export const PDF_STYLES = `
  .pdf-container * { 
    font-family: 'Tajawal', 'Segoe UI', Tahoma, Arial, sans-serif !important; 
    box-sizing: border-box !important;
  }
  .pdf-container .header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: start !important;
    margin-bottom: 10mm !important;
    padding: 0 0 3mm 0 !important;
  }
  .pdf-container .ministry-logo {
    width: 120px !important;
    height: 80px !important;
    object-fit: contain !important;
    display: block !important;
    margin: 5px auto 3mm auto !important;
  }
  .pdf-container .report-title {
    text-align: center !important;
    font-size: 22px !important;
    font-weight: bold !important;
    color: #174459 !important;
    margin: -10mm 0 5mm 0 !important;
  }
  .pdf-container table {
    width: 100% !important;
    border-collapse: collapse !important;
    font-size: 12px !important;
    margin-top: 3mm !important;
  }
  .pdf-container table th {
    background-color: #0DA9A6 !important;
    color: white !important;
    padding: 12px 8px !important;
    border: 1px solid #000 !important;
    text-align: center !important;
    font-weight: bold !important;
  }
  .pdf-container table td {
    padding: 10px 8px !important;
    border: 1px solid #000 !important;
    text-align: center !important;
  }
`;

// أنماط التصوير المخصصة
export const CANVAS_CLONE_STYLES = `
  * { 
    font-family: 'Tajawal', 'Segoe UI', Tahoma, Arial, sans-serif !important; 
    box-sizing: border-box !important;
  }
  .school-name { 
    font-weight: 700 !important; 
    color: #1f2937 !important; 
    font-size: 13px !important;
    margin-top: 8px !important;
  }
  .title { 
    font-size: 22px !important; 
    font-weight: bold !important; 
    color: #174459 !important;
    text-align: center !important;
    margin: -10mm 0 5mm 0 !important;
  }
  .logo-section img { 
    width: 120px !important; 
    height: 80px !important;
    object-fit: contain !important;
    display: block !important;
    margin: 5px auto 5mm auto !important;
  }
  .header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: start !important;
    margin-bottom: 12mm !important;
    padding: 0 0 3mm 0 !important;
    position: relative !important;
  }
  .table {
    width: 100% !important;
    border-collapse: collapse !important;
    font-size: 12px !important;
    margin-top: 5mm !important;
  }
  .table th {
    background-color: #0DA9A6 !important;
    color: white !important;
    padding: 12px 8px !important;
    border: 1px solid #000 !important;
    text-align: center !important;
    font-weight: bold !important;
    font-size: 12px !important;
  }
  .table td {
    padding: 10px 8px !important;
    border: 1px solid #000 !important;
    text-align: center !important;
    font-size: 11px !important;
  }
`;